import { Fragment } from 'react';
import {
  FaChartLine,
  FaChevronRight,
  FaCode,
  FaGraduationCap,
  FaPencilRuler,
  FaSearch,
} from 'react-icons/fa';
import { ENGAGEMENT_PROCESS, PROCESS_STEPS } from '../../content/home';
import styles from './EngagementProcess.module.scss';

const PROCESS_ICONS = {
  search: FaSearch,
  pencil: FaPencilRuler,
  code: FaCode,
  graduation: FaGraduationCap,
  chart: FaChartLine,
} as const;

/**
 * Understand -> Design -> Build -> Enable -> Improve, with the arrows between
 * the cards that make it read as a sequence rather than five unrelated tiles.
 *
 * One component for the homepage and /services. Both pages described the same
 * steps from the same PROCESS_STEPS data but rendered them through their own
 * markup and their own stylesheet, so the two could drift. There is one
 * description of how an engagement runs, and now one thing that draws it.
 *
 * The arrows are list items rather than pseudo-elements on the cards, because
 * they have to rotate to point down when the row stacks. They are
 * aria-hidden, so the list exposes only the steps themselves.
 */
const EngagementProcess = ({ heading = ENGAGEMENT_PROCESS.heading }: { heading?: string }) => (
  <section className={styles.engagementProcess}>
    <div className={styles.container}>
      <h2>{heading}</h2>

      <ol className={styles.steps}>
        {PROCESS_STEPS.map((step, index) => {
          const Icon = PROCESS_ICONS[step.iconKey];
          return (
            <Fragment key={step.id}>
              <li className={styles.step}>
                <span className={styles.stepNumber}>{step.number}</span>
                <Icon className={styles.stepIcon} aria-hidden="true" />
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </li>

              {index < PROCESS_STEPS.length - 1 && (
                <li className={styles.arrow} aria-hidden="true">
                  <FaChevronRight />
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </div>
  </section>
);

export default EngagementProcess;
